import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.stockSubLocationPage.title, 'Stock sub Location'),
  name: () => __(translations.stockSubLocationPage.name, 'Stock sub Location'),
  location: () => __(translations.stockSubLocationPage.location, 'Location'),
};
